var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_2724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 19C20.0001 19.5304 19.8168 20.0391 19.4907 20.4142C19.1645 20.7893 18.7222 21 18.2609 21H2.60876C2.14751 21 1.70516 20.7893 1.37901 20.4142C1.05286 20.0391 0.869629 19.5304 0.869629 19V8C0.869629 7.46957 1.05286 6.96086 1.37901 6.58579C1.70516 6.21071 2.14751 6 2.60876 6H6.08702L7.82615 3H13.0435L14.7827 6H18.2609C18.7222 6 19.1645 6.21071 19.4907 6.58579C19.8168 6.96086 20.0001 7.46957 20.0001 8V19Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 17C12.3558 17 13.9131 15.2091 13.9131 13C13.9131 10.7909 12.3558 9 10.4348 9C8.51381 9 6.95654 10.7909 6.95654 13C6.95654 15.2091 8.51381 17 10.4348 17Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_2724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8696,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.cfc34813c03e9f75ad44e32aeb2b53d0.svg";
export { ForwardRef as ReactComponent };